import * as React from 'react'

export const Search = () => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M49.3374 55.7612L55.6455 49.4922L50.6098 44.425L44.3017 50.694L49.3374 55.7612Z"
      fill="#704943"
    />
    <path
      d="M49.1147 8.43796C37.8886 -2.78823 19.8099 -2.78823 8.58371 8.29212C-2.64248 19.3725 -2.64248 37.597 8.43787 48.8231C19.5182 60.0493 37.7427 60.0493 48.9689 48.969C60.1951 37.8886 60.1952 19.6641 49.1147 8.43796Z"
      fill="#CAA5A1"
    />
    <path
      d="M12.812 44.449C4.06424 35.7013 4.06424 21.4134 12.9578 12.6657C21.7055 3.918 35.9934 3.918 44.7411 12.8116C53.4888 21.5593 53.4888 35.8472 44.5953 44.5949C35.8476 53.3424 21.5597 53.3424 12.812 44.449Z"
      fill="#EEC5C0"
    />
    <path
      d="M42.2626 42.2629C34.827 49.5526 22.5802 49.5526 15.2905 42.1171C7.85495 34.6815 7.85495 22.5806 15.4363 15.145C23.0177 7.70947 34.8271 7.70947 42.2627 15.145C49.6981 22.7263 49.6981 34.8274 42.2626 42.2629Z"
      fill="#FFDDD9"
    />
    <path
      d="M37.5969 37.5974C32.7856 42.4086 24.9127 42.4086 19.9556 37.5974C15.1444 32.7861 15.1444 24.9132 19.9556 19.9561C24.7668 15.1448 32.6398 15.1448 37.5969 19.9561C42.5539 24.9132 42.5539 32.7861 37.5969 37.5974Z"
      fill="#815954"
    />
    <path
      d="M67.3391 55.3849L58.2998 46.3456C57.7166 45.7624 56.8418 45.7624 56.2588 46.3456L46.1989 56.4055C45.6157 56.9887 45.6157 57.8635 46.1989 58.4466L55.2381 67.4859C58.5914 70.8391 63.9858 70.8391 67.3391 67.4859C70.6925 64.1326 70.6925 58.7381 67.3391 55.3849Z"
      fill="#9E7671"
    />
    <path
      d="M23.0175 24.33C25.1916 24.33 26.954 22.5676 26.954 20.3935C26.954 18.2194 25.1916 16.457 23.0175 16.457C20.8435 16.457 19.0811 18.2194 19.0811 20.3935C19.0811 22.5676 20.8435 24.33 23.0175 24.33Z"
      fill="white"
    />
    <path
      d="M28.2661 27.8296C29.5545 27.8296 30.5989 26.7852 30.5989 25.4968C30.5989 24.2085 29.5545 23.1641 28.2661 23.1641C26.9778 23.1641 25.9333 24.2085 25.9333 25.4968C25.9333 26.7852 26.9778 27.8296 28.2661 27.8296Z"
      fill="white"
    />
  </svg>
)
